module.exports = __webpack_public_path__ + "img/succeed.7ce9c7c3.png";